export const ALL_PAYMENT_SCOPES = "all";

export function indexPaymentItems(items) {
  const result = new Map();
  const visit = (entries) => entries.forEach((item) => {
    result.set(item.itemId, item);
    visit(item.children || []);
  });
  visit(items);
  return result;
}

export function filterPaymentsByItems(payments, items, scopeIds) {
  if (scopeIds == null) return payments;
  const allowedScopes = new Set(scopeIds);
  return payments.filter((payment) => allowedScopes.has(items.get(payment.contractItemId)?.contractItemScopeId));
}

export const paymentIdOf = (payment) => payment.contractPaymentId ?? payment.paymentId;

export function getContractPaymentAmount(payment, item) {
  return Math.round(payment.paymentAmount ?? (Number(item?.unitPrice || 0) * Number(payment.paymentQuantity || 0)));
}

export function groupContractPayments(payments, itemIndex, sections) {
  const scopeIndex = new Map(sections.flatMap((section) => (section.scopes || []).map((scope) => [
    scope.contractItemScopeId, { section, scope },
  ])));
  const groups = new Map();
  payments.forEach((payment) => {
    const item = itemIndex.get(payment.contractItemId);
    const scopeId = item?.contractItemScopeId;
    const entry = scopeIndex.get(scopeId);
    const sectionKey = entry?.section.contractSectionId ?? "legacy";
    const scopeKey = scopeId ?? "legacy";
    if (!groups.has(sectionKey)) groups.set(sectionKey, {
      id: sectionKey,
      name: entry?.section.sectionName || (sections.length ? "Hạng mục chưa phân loại" : "Hạng mục đơn"),
      displayOrder: entry?.section.displayOrder ?? Number.MAX_SAFE_INTEGER,
      scopes: new Map(),
    });
    const sectionGroup = groups.get(sectionKey);
    if (!sectionGroup.scopes.has(scopeKey)) sectionGroup.scopes.set(scopeKey, {
      id: scopeKey,
      name: entry?.scope.scopeName || (scopeId != null ? `Scope #${scopeId}` : "Hạng mục hợp đồng chưa phân scope"),
      displayOrder: entry?.scope.displayOrder ?? Number.MAX_SAFE_INTEGER,
      readOnly: entry?.section.isActive === false || entry?.scope.isEditable === false || entry?.scope.scopeType === "TOTAL",
      items: [],
    });
    sectionGroup.scopes.get(scopeKey).items.push({ ...payment,
      itemCode: item?.itemCode || payment.itemCode,
      itemName: item?.itemName || payment.itemName,
      unit: item?.unit || payment.unit,
      unitPrice: item?.unitPrice ?? payment.unitPrice,
      contractItemScopeId: scopeId,
      paymentAmount: getContractPaymentAmount(payment, item),
    });
  });
  const compareGroups = (left, right) => left.displayOrder - right.displayOrder || left.name.localeCompare(right.name, "vi");
  return [...groups.values()].sort(compareGroups).map((group) => ({ ...group,
    scopes: [...group.scopes.values()].sort(compareGroups).map((scope) => ({ ...scope,
      items: scope.items.sort((left, right) => String(left.itemCode || "").localeCompare(String(right.itemCode || ""), "vi", { numeric: true })),
    })),
  }));
}
